export class ToySafetyReport {
  public constructor(
    public name: string,
    public versionNumber: number,
    public isApproved: boolean,
    public status: string,
    public material: string[],
    public webUrl: URL,
    public mouldNumber: string | undefined
  ) {}
}
